/* eslint-disable jsx-a11y/anchor-is-valid */
import {Button} from '@mui/material'
import moment from 'moment'
import React, {FC, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { InputBanCas, InputDatePickerBanCas } from '../../../../app/modules/Bancassurance/components'
import { AutoCompleteBanCas } from '../../../../app/modules/Bancassurance/components/AutoCompleteBanCas'
import {RootState} from '../../../../setup'
import {KTSVG} from '../../../helpers'
import * as filter from '../../../../app/redux-commons/FilterRedux/filterRedux'
import { useLocalStorage } from '../../../../app/utils'
import { ContractStatusType } from '../../../../app/enums'

const DrawerMessenger: FC = () => {
  const [listUser, setListUser] = useState<any>([])
  const [listCategory] = useLocalStorage<any[]>('category', [])
  const [partner] = useLocalStorage<string[]>('view:partner', [])
  const filterState = useSelector((state: RootState) => state.filter).FilterPersonInsurance
  const dispatch = useDispatch()

  const handleFilter = () => {
    dispatch(filter.actions.updateApplyFilterStatus(true))
  }

  const handleClearFilter = () => {
    dispatch(filter.actions.cleanFilterInfo('FilterPersonInsurance'))
  }

  useEffect(() => {
    let arr: any = []
    arr.push({
      label: 'Tất cả',
      value: '',
    })
    listCategory.map((o: any) => {
      arr.push({
        label: o.name,
        value: o.code,
      })
    })

    setListUser(arr)
  }, [])

  return (
    <div
      id='kt_drawer_chat'
      className='bg-white'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'350px', 'md': '350px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_drawer_chat_toggle'
      data-kt-drawer-close='#kt_drawer_chat_close'
    >
      <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
        <div className='card-header pe-5' id='kt_drawer_chat_messenger_header' style={{backgroundColor: 'inherit'}}>
          <div className='card-title'>
            <div className='d-flex justify-content-center flex-column me-3'>
              <div className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                Bộ lọc
              </div>

              {/* <div className='mb-0 lh-1'>
              <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>
              <span className='fs-7 fw-bold text-gray-400'>Active</span>
            </div> */}
            </div>
          </div>

          <div className='card-toolbar'>
            {/* <div className='me-2'>
            <button
              className='btn btn-sm btn-icon btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <i className='bi bi-three-dots fs-3'></i>
            </button>
          </div> */}

            <div className='btn btn-sm btn-icon btn-active-light-primary' id='kt_drawer_chat_close'>
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
            </div>
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-12'>
              <InputDatePickerBanCas
                defaultValue={
                  filterState.fromDate
                    ? moment(filterState.fromDate, 'YYYY/MM/DD').toDate()
                    : undefined
                }
                id='fromDate'
                label='Từ ngày'
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <InputDatePickerBanCas
                defaultValue={
                  filterState.toDate ? moment(filterState.toDate, 'YYYY/MM/DD').toDate() : undefined
                }
                id='toDate'
                label='Tới ngày'
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <AutoCompleteBanCas
                id='partnerCode'
                options={partner}
                label='Đối tác/đại lý'
                defaultValue={filterState.partnerCode}
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <AutoCompleteBanCas
                id='userCode'
                options={listUser}
                label='Cán bộ bán hàng'
                defaultValue={filterState.userCode}
                formName='FilterPersonInsurance'
              />
            </div>
            {/* <div className='col-12'>
              <AutoCompleteBanCas
                id='ProductCode'
                options={[]}
                label='Sản phẩm'
                defaultValue={filterState.userCode}
                formName='FilterPersonInsurance'
              />
            </div> */}
            <div className='col-12'>
              <InputBanCas
                label='Số hợp đồng'
                placehoder='Số hợp đồng'
                required={false}
                inputValue={filterState.contractNo ? filterState.contractNo : ''}
                id='contractNo'
                name='contractNo'
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <InputBanCas
                label='Số Giấy chứng nhận'
                placehoder='Số Giấy chứng nhận'
                required={false}
                inputValue={filterState.certificatetNo ? filterState.certificatetNo : ''}
                id='certificatetNo'
                name='certificatetNo'
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <InputBanCas
                label='Tên khách hàng'
                placehoder='Tên khách hàng'
                required={false}
                inputValue={filterState.customerName ? filterState.customerName : ''}
                id='customerName'
                name='customerName'
                formName='FilterPersonInsurance'
              />
            </div>
            <div className='col-12'>
              <AutoCompleteBanCas
                id='contractStatus'
                options={ContractStatusType}
                label='Trạng thái hợp đồng'
                defaultValue={filterState.contractStatus}
                formName='FilterPersonInsurance'
              />
            </div>
          </div>
        </div>
        <div className='card-footer'>
          <div>
            <Button
              variant='contained'
              fullWidth
              size='medium'
              className='modal-footer-btn'
              sx={{marginTop: '7px', marginBottom: '7px'}}
              onClick={handleFilter}
            >
              Tìm kiếm
            </Button>
          </div>
          <div>
            <Button
              variant='outlined'
              size='medium'
              fullWidth
              className='modal-footer-btn'
              sx={{marginBottom: '7px'}}
              onClick={handleClearFilter}
            >
              Làm mới bộ lọc
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {DrawerMessenger}
